var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { runtime } from '../../../../classes/runtime/Runtime';
import { AvailablePopover } from '../../../../components/other/AvailablePopover';
let MenubarIconReportError = class MenubarIconReportError extends React.PureComponent {
    get color() {
        if (this.props.app.menubar.menubarRight.isReportErrorIconHovering) {
            return '#fff';
        }
        return '#9d9d9d';
    }
    render() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            this.reportDialog_,
            React.createElement(AvailablePopover, { content: React.createElement("span", { style: { fontWeight: 500, fontSize: 14 } }, "Fehler auf dieser Seite melden"), overlayStyle: { paddingTop: 0 }, placement: "bottom", trigger: "hover" },
                React.createElement("div", { onClick: app.menubarRight.toggleReportErrorDialog, className: "MenubarRightIconButton", style: {
                        color: this.color
                    }, onMouseEnter: action(() => {
                        const load = runtime.streamedPackages.Lazy;
                        app.menubarRight.isReportErrorIconHovering = true;
                    }), onMouseLeave: action(() => (app.menubarRight.isReportErrorIconHovering = false)) },
                    React.createElement("i", { className: "fas fa-exclamation-triangle" })))));
    }
    get reportDialog_() {
        const { app } = this.props;
        if (!app.menubarRight.isReportErrorModalOpen)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { ReportErrorDialog_ } = runtime.streamedPackages.Lazy.components;
        return React.createElement(ReportErrorDialog_, { app: app });
    }
};
MenubarIconReportError = __decorate([
    observer
], MenubarIconReportError);
export { MenubarIconReportError };
